/** One row of `SELECT ticket_status, COUNT(*) FROM tickets GROUP BY ticket_status`. */
export interface ITicketStatusCount {
  /** `null` for tickets whose status column is unset. */
  ticketStatus: string | null;
  count: number;
}

export interface ITicketStatusCounts {
  counts: ITicketStatusCount[];
  total: number;
}

/**
 * The full `ticketStatus` enumeration from the Strapi ticket schema, in lifecycle
 * order. The endpoint mirrors the `GROUP BY`, so a status with no tickets is simply
 * absent from the response — the page zero-fills from this list so "none" reads as
 * `0` rather than a missing row.
 */
export const TICKET_STATUSES = [
  "held",
  "reserved",
  "waitlisted",
  "checked_in",
  "redeemed",
  "expired",
  "cancelled",
] as const;
